import React, { useEffect, useState } from "react";
import { useParams, useHistory } from "react-router-dom";
import { Card, CardBody } from "../../../../_metronic/_partials/controls";
import {
	getEscapeRoomById,
	updateEscapeRoom,
	deleteEscapeRoom,
} from "../../../../api/escape-room";
import { alertError, alertSuccess } from "../../../../utils/logger";
import ConfirmDialog from "../../../components/dialogs/ConfirmDialog";
import EscapeRoomEditor from "./EscapeRoomEditor";

export default function EscapeRoomEditPage() {
	const { id } = useParams();
	const history = useHistory();
	const [escapeRoom, setEscapeRoom] = useState(null);
	const [loading, setLoading] = useState(false);
	const [deleteConfirm, setDeleteConfirm] = useState(false);
	const [loadError, setLoadError] = useState(false);

	useEffect(() => {
		if (!id) return;
		setLoadError(false);
		getEscapeRoomById(id)
			.then((res) => {
				if (res.status === 200 && res.data) {
					setEscapeRoom(res.data);
				} else {
					setLoadError(true);
				}
			})
			.catch(() => {
				alertError({ customMessage: "No se encontró el escape room." });
				setLoadError(true);
			});
	}, [id]);

	const handleSave = (data, opts = {}) => {
		if (!id || loading) return;
		setLoading(true);
		updateEscapeRoom(id, data)
			.then((res) => {
				if (res.status === 200) {
					if (!opts.silent) alertSuccess({ customMessage: "Guardado." });
					setEscapeRoom(res.data);
				}
			})
			.catch((err) => {
				alertError({ error: err, customMessage: "No se pudo guardar." });
			})
			.finally(() => setLoading(false));
	};

	const handleDelete = () => {
		if (!id) return;
		deleteEscapeRoom(id)
			.then((res) => {
				if (res.status === 204) {
					alertSuccess({ customMessage: "Escape room eliminado." });
					history.push("/dashboard");
				}
			})
			.catch((err) => {
				alertError({ error: err, customMessage: "No se pudo eliminar." });
			});
	};

	if (!escapeRoom) {
		return (
			<Card>
				<CardBody>{loadError ? "No se encontró el escape room." : "Cargando…"}</CardBody>
			</Card>
		);
	}

	return (
		<>
			<EscapeRoomEditor
				key={escapeRoom._id}
				escapeRoom={escapeRoom}
				onSave={handleSave}
				onDelete={() => setDeleteConfirm(true)}
				saving={loading}
			/>

			<ConfirmDialog
				title="¿Eliminar este escape room?"
				open={deleteConfirm}
				setOpen={setDeleteConfirm}
				onConfirm={handleDelete}
			/>
		</>
	);
}
